// src/components/Header.js (Versão Final com "Termos de Uso" adicionado)

import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebaseconfig";
import { useAuth } from "../Context/AuthContext";
import "./Header.css";
import { FaCog, FaBars, FaTimes } from "react-icons/fa";

import logoPrincipal from "../assets/custosagro2.png";
import logoCalcLeite from "../assets/calcleite.png";
import logoCalcCafe from "../assets/calccafe.png";
import logoCalcBov from "../assets/calcbov.png";
import logoCalcAgro from "../assets/calcagro.png";

const appConfig = {
  calcleite: { className: 'theme-calcleite', logo: logoCalcLeite, name: 'CalcLeite' },
  calccafe:  { className: 'theme-calccafe',  logo: logoCalcCafe,  name: 'CalcCafé'  },
  calcbov:   { className: 'theme-calcbov',   logo: logoCalcBov,   name: 'CalcBov'   },
  calcagro:  { className: 'theme-calcagro',  logo: logoCalcAgro,  name: 'CalcAgro'  },
};

const Header = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentTheme, setCurrentTheme] = useState({});

  const { user, userData } = useAuth();

  const location = useLocation();
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setActiveMenu(null);
      }
    }
    if (activeMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeMenu]);

  useEffect(() => {
    const activeRouteKey = Object.keys(appConfig).find(key => 
      location.pathname.startsWith(`/${key}`)
    );
    setCurrentTheme(activeRouteKey ? appConfig[activeRouteKey] : {});
  }, [location]);

  const handleLogout = async () => {
    await signOut(auth);
    closeAllMenus();
  };

  const togglePanel = (menuName) => {
    setActiveMenu(activeMenu === menuName ? null : menuName);
  };

  const closeAllMenus = () => {
    setMenuOpen(false);
    setActiveMenu(null);
  };

  const subscribedApps = user && userData ? 
    Object.keys(appConfig).filter(appKey => userData[appKey] === true)
    : [];

  return (
    <header className={`header ${currentTheme.className || ''}`}>
      <div className="logo">
        <Link to="/" onClick={closeAllMenus}>
          <img 
            src={currentTheme.logo || logoPrincipal} 
            alt={currentTheme.logo ? "Logo do App" : "Custos Agro Logo"} 
          />
        </Link>
      </div>

      <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>

      <nav className={menuOpen ? "active" : ""}>
        <ul>
          <li><Link to="/" onClick={closeAllMenus}>Home</Link></li>

          {user && subscribedApps.length > 0 && (
            <li className="dropdown-container">
              <button className="nav-button my-apps-button" onClick={() => togglePanel('my-apps')}>Meus Apps</button>
              {activeMenu === 'my-apps' && (
                <div ref={menuRef} className="panel-menu my-apps-panel">
                  <div className="panel-header">
                    <span>Acesso Rápido</span>
                    <button onClick={() => setActiveMenu(null)}><FaTimes /></button>
                  </div>
                  <ul>
                    {subscribedApps.map(appKey => (
                      <li key={appKey}>
                        <Link to={`/${appKey}/app`} onClick={closeAllMenus}>
                          {appConfig[appKey].name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          )}

          <li className="dropdown-container">
            <button className="nav-button" onClick={() => togglePanel('apps')}>Apps</button>
            {activeMenu === 'apps' && (
              <div ref={menuRef} className="panel-menu apps-panel">
                <div className="panel-header">
                  <span>Navegar</span>
                  <button onClick={() => setActiveMenu(null)}><FaTimes /></button>
                </div>
                <ul>
                  <li><Link to="/calcleite" onClick={closeAllMenus}>CalcLeite</Link></li>
                  <li><Link to="/calccafe" onClick={closeAllMenus}>CalcCafé</Link></li>
                  <li><Link to="/calcbov" onClick={closeAllMenus}>CalcBov</Link></li>
                  <li><Link to="/calcagro" onClick={closeAllMenus}>CalcAgro</Link></li>
                </ul>
              </div>
            )}
          </li>

          <li><Link to="/politica-privacidade" onClick={closeAllMenus}>Política de Privacidade</Link></li>
          <li><Link to="/termos" onClick={closeAllMenus}>Termos de Uso</Link></li>
          <li><Link to="/sobre" onClick={closeAllMenus}>Sobre Nós</Link></li>
          <li><Link to="/contatos" onClick={closeAllMenus}>Contatos</Link></li>

          {user ? (
            <li className="dropdown-container">
              <button className="nav-button icon-button" onClick={() => togglePanel('settings')}>
                <FaCog size={24} />
              </button>
              {activeMenu === 'settings' && (
                <div ref={menuRef} className="panel-menu settings-panel">
                  <div className="panel-header">
                    <span>Configurações</span>
                    <button onClick={() => setActiveMenu(null)}><FaTimes /></button>
                  </div>
                  <ul>
                    <li><Link to="/conta" onClick={closeAllMenus}>Conta</Link></li>
                    <li><Link to="/perfil" onClick={closeAllMenus}>Perfil</Link></li>
                    <li onClick={handleLogout}>Logout</li>
                  </ul>
                </div>
              )}
            </li>
          ) : (
            <li><Link to="/login" className="login-btn" onClick={closeAllMenus}>Login</Link></li>
          )}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
